import { GitBranch } from '../git.model';

export function getFilteredAndSortedBranches(branches: GitBranch[], activeBranch: GitBranch, filterPhrase: string) {
  return getFilteredBranches(branches, filterPhrase)
    .slice(0)
    .sort((a, b) => {
      if (a.default) {
        return -1;
      }

      if (b.default) {
        return 1;
      }

      if (activeBranch) {
        if (activeBranch.name === a.name) {
          return -1;
        }
        if (activeBranch.name === b.name) {
          return 1;
        }
      }

      if (b.committerDate && a.committerDate) {
        return b.committerDate.valueOf() - a.committerDate.valueOf();
      }

      return 0;
    });
}

function getFilteredBranches(branches: GitBranch[], filterPhrase: string) {
  return branches.filter((branch) => branch.name.toLowerCase().includes(filterPhrase.toLowerCase()));
}
